// extracted by mini-css-extract-plugin
module.exports = {"situationPage":"SituationPage_situationPage__YRlNk","content":"SituationPage_content__4crTd","pullUp":"SituationPage_pullUp__UpKbB"};